import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { ItemTipoCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-item-tipo-multiselect',
    templateUrl: './item-tipo-multiselect.component.html',
    styleUrls: ['./item-tipo-multiselect.component.less']
})
export class ItemTipoMultiselectComponent implements OnInit {
    /** Tipos de itens selecionados */
    @Input() idsItensTipos: number[];
    /** Ao alterar a seleção dos tipos de itens */
    @Output() idsItensTiposChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    /** Se deve exibir a opção de selecionar a opção de tipo de item nulo ou seja, para filtrar registros que não possuem o tipo de item */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar o tipo de item nulo */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção do tipo de item nulo */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Tipo';
    @Input() checked = 'Tipo';
    @Input() checkedPlural = 'Tipos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum tipo encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private itemTipoCrudHttpService: ItemTipoCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-item-tipo ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos de itens para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        this.itemTipoCrudHttpService.search()
            .pipe(
                take(1)
            )
            .subscribe(
                entities => {
                    // Opção de selecionar a opção de tipo de item nulo
                    if (this.showNullOption) {
                        selects.push({
                            id: 0,
                            name: 'NÃO INFORMADO'
                        });
                    }
                    // Adicionando os tipos de itens ao multiselect
                    if (entities) {
                        entities.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os tipos de itens', error);
                }
            );
    }

    /** Ao alterar a seleção da opção do tipo de item nulo */
    private onChangeNullOption() {
        this.nullOption = this.idsItensTipos.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção dos tipos de itens */
    onChange() {
        this.onChangeNullOption();
        this.idsItensTiposChange.emit(this.idsItensTipos);
    }
}
